
// RPC call utilities with timeout handling
import { supabase } from '../client';

export const safeRPC = async <T = any>(
  functionName: string, 
  params: any = {},
  options: { timeout?: number } = {}
): Promise<T | null> => {
  const timeout = options.timeout || 5000; // Reduced to 5s for faster UX
  
  try {
    console.log(`Making RPC call to ${functionName}`, params);
    
    // Create a timeout promise
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error(`RPC call ${functionName} timed out`)), timeout);
    });
    
    // Race between the RPC call and timeout
    // Use 'any' type assertion to bypass strict typing
    const rpcPromise = (supabase.rpc as any)(functionName, params);
    
    const { data, error } = await Promise.race([rpcPromise, timeoutPromise]) as any;
    
    if (error) {
      console.error(`RPC ${functionName} error:`, error);
      return null;
    }
    
    console.log(`RPC ${functionName} successful:`, data);
    return data;
  } catch (error: any) {
    console.error(`RPC ${functionName} failed:`, error);
    throw error;
  }
};
